<template>
  <div class="container">
    <!-- 头 -->
    <div>
      <a-layout>
        <a-layout-content :style="{ margin: '5px 5px', padding: '8px', background: '#fff' }">
          <a-tabs
            style="height: 43px"
            default-active-key="1"
            @change="callback"
            :forceRender="true"
          >
            <!-- <a-tab-pane key="1" tab="组织机构部门（行政组织）"> </a-tab-pane> -->
            <a-tab-pane
              :key="2"
              tab="党委组织架构"
            ></a-tab-pane>
            <a-tab-pane
              :key="3"
              tab="处室组织架构"
            ></a-tab-pane>
            <a-tab-pane
              :key="4"
              tab="教学组织架构"
            ></a-tab-pane>
            <a-tab-pane
              :key="5"
              tab="工会组织架构"
            ></a-tab-pane>
            <a-tab-pane
              :key="6"
              tab="教研组织架构"
            ></a-tab-pane>
          </a-tabs>
        </a-layout-content>
      </a-layout>
    </div>

    <a-layout
      class="layout"
      :style="{ height: '100%' }"
    >
      <!-- 左侧 -->
      <a-layout-sider
        width="400px"
        :style="{
                    margin: '5px 5px',
                    padding: '24px',
                    background: '#fff',
                    minHeight: '750px'
                }"
      >
        <div style="border-bottom: 1px solid rgb(212, 212, 212); font-size: 21px">
          <a-input-search
            placeholder="请输入组织层级名称"
            v-model="searchValue"
            style="width: 280px; margin-bottom: 6px"
            @pressEnter="onSearch"
          />

          <a-icon
            @click="addClick"
            style="margin-left: 10px"
            type="plus-circle"
            theme="filled"
          />
        </div>

        <a-tree
          :checkedKeys="keyAry"
          class="draggable-tree"
          :expandedKeys="expandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="commData"
          @expand="onExpand"
          @select="selectClick"
        >
          <template #title="{ key: treeKey, title }">
            <a-dropdown :trigger="['contextmenu']">
              <span v-if="title.indexOf(searchValue) > -1">
                {{ title.substr(0, title.indexOf(searchValue)) }}
                <span style="color: #f50">{{ searchValue }}</span>
                {{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
              </span>
              <span v-else>{{ title }}</span>
              <template #overlay>
                <a-menu @click="
                                        ({ key: menuKey }) =>
                                            onContextMenuClick(treeKey, menuKey, title)
                                    ">
                  <a-menu-item key="1">修改组织名称</a-menu-item>
                  <a-menu-item key="2">添加子组织</a-menu-item>
                  <!-- <a-menu-item key="3">删除组织</a-menu-item> -->
                  <a-menu-item key="4">组织Id：{{ treeKey }}</a-menu-item>
                  <a-menu-item
                    key="5"
                    v-if="treeKey != commData[0].key"
                  >
                    上移
                  </a-menu-item>
                  <a-menu-item
                    key="6"
                    v-if="treeKey != commData[0].key"
                  >
                    下移
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </template>
        </a-tree>
      </a-layout-sider>
      <!-- 右侧 -->
      <a-layout-content :style="{
                    margin: '5px ',
                    padding: '24px',
                    background: '#fff',
                    minHeight: '750px',
                    display: 'flex',
                    flexDirection: 'column'
                }">
        <div style="
                        font-weight: bold;
                        font-size: 15px;
                        height: 40px;
                        width: 100%;
                        line-height: 40px;
                    ">
          <div style="float: left; width: 80%">
            <a-space
              :size="100"
              align="start"
            >
              <span>{{ basicGwData.name }}({{ personTotal }}人)</span>
            </a-space>
          </div>
          <div style="float: left; width: 20%">
            <a-tabs
              type="card"
              size="small"
              style="height: 43px"
              default-active-key="1"
              @change="changeStatus"
              :forceRender="true"
            >
              <a-tab-pane
                key="1"
                tab="岗位信息"
                force-render
              ></a-tab-pane>
              <a-tab-pane
                key="2"
                tab="人员信息"
              ></a-tab-pane>
            </a-tabs>
          </div>
        </div>
        <div style="height: 0; flex: 1">
          <div style="height: 100%">
            <div
              v-show="modelView == 1"
              style="height: 100%"
            >
              <div
                style="padding: 20px 30px"
                class="div1"
              >
                <div style="
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                    ">
                  <span>岗位信息（{{ gwTotal }}个)</span>
                  <a-space style="float: right">
                    <a-button
                      v-if="hasPermission()"
                      @click="gwOpenViewClick(1)"
                      type="primary"
                      ghost
                    >
                      新增
                    </a-button>
                  </a-space>
                </div>
                <a-table
                  size="middle"
                  :columns="gwColumns"
                  :data-source="gwData"
                  :bordered="true"
                  :pagination="paginationGw"
                  style="margin-top: 10px; height: 0; flex: 1"
                  :scroll="{ y: 500 }"
                >
                  <span
                    slot="action"
                    slot-scope="scope"
                  >
                    <a @click="gwOpenViewClick(3, scope)">查看</a>
                    &nbsp;&nbsp;&nbsp;
                    <a v-if="hasPermission()" @click="gwOpenViewClick(2, scope)">编辑</a>
                    &nbsp;&nbsp;&nbsp;
                    <a-popconfirm v-if="hasPermission()"
                      title="确定要删除吗？"
                      @confirm="gwOpenViewClick(4, scope)"
                    >
                      <a-icon
                        slot="icon"
                        type="question-circle-o"
                        style="color: red"
                      />
                      <a>删除</a>
                      &nbsp;&nbsp;&nbsp;
                    </a-popconfirm>
                  </span>
                </a-table>
              </div>
            </div>
            <div
              v-show="modelView == 2"
              style="height: 100%"
            >
              <div
                style="padding: 20px 30px"
                class="div1"
              >
                <div style="
                                        display: flex;
                                        justify-content: space-between;
                                        align-items: center;
                                    ">
                  <span>人员信息（{{ gwPersonNumber }}人）</span>
                  <a-space style="float: right">
                    <a-button
                      v-if="hasPermission()"
                      @click="openAddPerView"
                      type="primary"
                      ghost
                    >
                      新增
                    </a-button>
                    <a-popconfirm v-if="hasPermission()"
                      placement="topLeft"
                      ok-text="Yes"
                      cancel-text="No"
                      @confirm="deleteSelect"
                    >
                      <a-icon
                        slot="icon"
                        type="question-circle-o"
                        style="color: red"
                      />
                      <template slot="title">
                        确定要批量删除这些人员？
                      </template>
                      <a-button
                        type="primary"
                        ghost
                      >删除</a-button>
                    </a-popconfirm>
                    <a-button
                      v-if="hasPermission()"
                      @click="openChangeGw"
                      type="primary"
                      ghost
                    >
                      人员调整
                    </a-button>
                    <a-button
                      @click="handleExport"
                      type="primary"
                      ghost
                      :loading="exportLoading"
                    >
                      导出
                    </a-button>
                    <a-button
                      v-if="hasPermission()"
                      @click="handleImport"
                      type="primary"
                      ghost
                    >
                      导入
                    </a-button>

                  </a-space>
                </div>
                <a-table
                  :row-selection="{
                                        selectedRowKeys: selectedRowKeys,
                                        onChange: onSelectChange
                                    }"
                  :columns="columnsPreson"
                  :data-source="dataPerson"
                  :bordered="true"
                  :pagination="paginationPer"
                  size="middle"
                  style="margin-top: 10px"
                  :scroll="{ y: 500 }"
                >
                  <span
                    slot="action"
                    slot-scope="scope"
                  >
                    <a v-if="hasPermission()" @click="personDrawer(scope, 1)">人员调整</a>
                    &nbsp;&nbsp;&nbsp;
                    <a-popconfirm v-if="hasPermission()"
                      title="确定要删除吗？"
                      @confirm="personDrawer(scope, 2)"
                    >
                      <a-icon
                        slot="icon"
                        type="question-circle-o"
                        style="color: red"
                      />
                      <a>删除</a>
                      &nbsp;&nbsp;&nbsp;
                    </a-popconfirm>
                  </span>
                </a-table>
              </div>
            </div>
          </div>
        </div>
      </a-layout-content>
    </a-layout>

    <!-- 岗位权限 新增 编辑 查看-->

    <a-drawer
      :style="{ 'pointer-events': gwIscheck }"
      :width="720"
      :title="gwDrawerTitle"
      placement="right"
      :closable="true"
      :visible="gwInfoView"
      @close="onCloseGw"
    >
      <a-form-model
        :model="selectPostForm"
        ref="selectPostForm"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item label="组织层级">
          <div>{{ gwDrawerOrganTitle }}</div>
        </a-form-model-item>
        <a-form-model-item
          label="岗位"
          prop="postId"
        >
          <a-select
            style="width: 200px"
            @change="changePost"
            v-model="selectPostForm.postId"
            :disabled="gwForm.type != 1 ? true : false"
            showSearch
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="item in postList"
              :key="item.postId"
            >
              {{ item.postName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="分管岗位">
          <a-radio-group v-model="form.isManage" @change="handleIsManageChange" :disabled="gwForm.type == 3">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-if="form.isManage" label="分管类型">
          <a-select
            v-model="form.manageType"
            placeholder="请选择分管类型"
            style="width: 100%"
            @change="handleManageTypeChange"
            :disabled="gwForm.type == 3"
          >
            <a-select-option
              v-for="item in manageTypeOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="form.isManage" label="分管范围">
          <a-tree-select
            v-model="form.manageOrganList"
            placeholder="选择分管组织"
            style="width: 100%"
            :tree-data="organTree"
            :max-tag-count="3"
            multiple
            allow-clear
            show-search
            @change="handleManageOrganChange"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :disabled="gwForm.type == 3"
          />
          <p style="margin-top: 5px; font-size: 12px; color: #999;">
            默认选择当前组织及其所有下级组织
          </p>
        </a-form-model-item>
        <a-form-model-item v-if="form.isManage" label="分管级数">
          <a-select
            v-model="form.manageLevel"
            placeholder="请选择分管级数"
            style="width: 100%"
            :disabled="gwForm.type == 3"
          >
            <a-select-option :value="1">一级</a-select-option>
            <a-select-option :value="2">二级</a-select-option>
            <a-select-option :value="3">三级</a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <br />
      <div style="
                    width: 100%;
                    border-bottom: solid;
                    font-size: 16px;
                    border-width: 1px;
                    font-weight: bold;
                ">
        基础功能
      </div>
      <div
        class="drawerCotent"
        v-bind:key="obj.id"
        v-for="(obj, key) in assignedBasicGwList"
      >
        <div class="span2">
          <span style="font-size: 1.25rem">{{ obj.title }}</span>
        </div>
        <div
          class="content"
          v-if="obj.id == 1"
        >
          <div class="qw">
            <div>
              <a-row :gutter="10">
                <template v-for="(child, key2) in obj.children">
                  <a-col v-bind:key="child.id" :span="6">
                    <a-checkbox
                      default-checked
                      disabled
                      class="box1"
                      style="
                                                margin-left: 13px;
                                                padding: 3px 7px;
                                                color: black;
                                            "
                    >
                      {{ child.title }}
                    </a-checkbox>
                  </a-col>
                </template>
              </a-row>
            </div>
          </div>
        </div>
        <div
          v-else
          v-bind:key="e.id"
          v-for="(e, key1) in obj.children"
        >
          <div class="content">
            <div class="qw">
              <div :style="{ borderBottom: '1px solid #E9E9E9' }">
                <a-checkbox
                  default-checked
                  disabled
                  style="margin: 5px 20px"
                >
                  {{ e.title }}
                </a-checkbox>
              </div>
              <a-row :gutter="10">
                <template v-for="(child, key2) in e.children">
                  <a-col v-bind:key="child.id" :span="6">
                    <a-checkbox
                      default-checked
                      disabled
                      class="box1"
                      style="margin-left: 13px; padding: 3px 7px"
                    >
                      {{ child.title }}
                    </a-checkbox>
                  </a-col>
                </template>
              </a-row>
            </div>
          </div>
        </div>
      </div>
      <div style="
                    width: 100%;
                    border-bottom: solid;
                    font-size: 16px;
                    border-width: 1px;
                    margin-top: 20px;
                    font-weight: bold;
                ">
        可分配功能
      </div>
      <div
        class="drawerCotent"
        v-bind:key="obj.id"
        v-for="(obj, key1) in optionalMenuGwList"
      >
        <div class="span2">
          <span style="font-size: 0.975rem">{{ obj.title }}</span>
        </div>
        <div v-bind:key="second.id" v-for="(second, key2) in obj.children">
          <div class="content">
            <div class="qw">
              <div :style="{ borderBottom: '1px solid #E9E9E9' }">
                <a-checkbox
                  :disabled="gwForm.type == 3 ? true : false"
                  :checked="second.check"
                  :indeterminate="second.allCheck"
                  style="margin: 5px 20px"
                  @change="e => changAll(e, obj.id, second.id)"
                >
                  {{ second.title }}
                </a-checkbox>
              </div>
              <a-row :gutter="10">
                <template v-for="(child, key3) in second.children">
                  <a-col v-bind:key="child.id" :span="6">
                    <a-checkbox
                      :disabled="gwForm.type == 3 ? true : false"
                      :checked="child.check"
                      class="box1"
                      @change="e => onChange(e, obj.id, second.id, child.id)"
                      style="margin-left: 13px; padding: 3px 7px"
                    >
                      {{ child.title }}
                    </a-checkbox>
                  </a-col>
                </template>
              </a-row>
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="gwForm.type != 3"
        :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1
                }"
      >
        <a-button
          :style="{ marginRight: '8px' }"
          @click="onCloseGw"
        >取消</a-button>
        <a-button
          type="primary"
          @click="gwSubClick"
        >提交</a-button>
      </div>
    </a-drawer>

    <!-- 组织树 修改组织名称-->

    <a-modal
      v-model="editTreeView"
      title="修改组织名称"
      @ok="handleEditClick"
      @cancel="editCancel"
      :centered="true"
      :maskClosable="false"
    >
      <a-form-model :model="editOrganForm">
        <a-form-model-item
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
          label="更改前名称"
        >
          <a-input v-emoji
            v-model="editOrganForm.preName"
            disabled
            width="600px"
          />
        </a-form-model-item>
        <a-form-model-item
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
          label="更改后名称"
        >
          <a-input v-emoji
            v-model="editOrganForm.editName"
            width="600px"
            v-decorator="[
                            'username',
                            { rules: [{ required: true, message: '请输入要更改的名称' }] }
                        ]"
            placeholder="请输入要更改的名称"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 组织树 添加子节点-->
    <a-modal
      v-model="addTreeView"
      title="添加子组织"
      @ok="handleAddClick"
      @cancel="addChildCancel"
      :centered="true"
      :maskClosable="false"
    >
      <a-form-model :model="addOrganChildrenForm">
        <a-form-model-item
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
          label="所属组织名称"
        >
          <a-input v-emoji
            v-model="addOrganChildrenForm.parentName"
            disabled
            width="600px"
          />
        </a-form-model-item>
        <a-form-model-item
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
          label="添加组织名称"
        >
          <a-input v-emoji
            v-model="addOrganChildrenForm.addName"
            width="600px"
            v-decorator="[
                            'username',
                            { rules: [{ required: true, message: '请输入要添加组织的名称' }] }
                        ]"
            placeholder="请输入要添加组织的名称"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 删除组织 -->
    <a-modal
      v-model="deleteTreeView"
      title="删除组织"
      @ok="handleDeleteClick"
      :centered="true"
      :maskClosable="false"
    >
      确认要删除该组织吗？
    </a-modal>

    <!-- 新增组织 -->
    <a-modal
      v-model="addView"
      title="添加组织"
      @ok="handleTreeAddClick"
      @cancel="addTreeCancel"
      :centered="true"
      :maskClosable="false"
    >
      <a-form-model :model="addOrganForm">
        <a-form-model-item
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
          label="组织名称"
        >
          <a-input v-emoji
            v-model="addOrganForm.addName"
            width="600px"
          />
        </a-form-model-item>
        <a-form-model-item
          :label-col="{ span: 7 }"
          :wrapper-col="{ span: 14 }"
          label="所属组织名称"
        >
          <a-tree-select
            v-model="addOrganForm.pid"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="commData"
            placeholder="Please select"
            tree-default-expand-all
          ></a-tree-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 人员新增 -->
    <a-drawer
      :visible="addPerView"
      title="添加人员"
      :width="500"
      @close="addPersonCancel"
      :closable="true"
    >
      <a-form-model
        :model="addPersonForm"
        ref="addPersonForm"
        :rules="addPersonFormRules"
      >
        <a-form-model-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 16 }"
          label="选择人员"
          prop="personId"
        >
          <a-select
            show-search
            placeholder="请选择人员"
            v-model="addPersonForm.personId"
            style="width: 100%"
            @change="handleChange"
            @search="filterOptionUser"
            :filter-option="false"
          >
            <template v-for="(e, key) in allPerSon">
              <a-select-option v-bind:key="e.id" :value="e.value">
                {{ e.title + '(' + e.mobile + ')' }}
              </a-select-option>
            </template>
            <a-select-option
              value="jack4"
              disabled
            >
              <a-pagination
                v-model="selectCurrent"
                @change="selectPageChange"
                :total="selectTotal"
                size="small"
                simple
                :pageSize="selectPageSize"
              />
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 16 }"
          label="选择岗位"
          prop="postId"
        >
          <a-select
            show-search
            placeholder="请选择岗位"
            option-filter-prop="children"
            v-model="addPersonForm.postId"
            style="width: 100%"
            :filter-option="filterPostOption"
            @change="handlePostChange"
          >
            <template v-for="(e, key) in allPost">
              <a-select-option v-bind:key="e.postId" :value="e.postId">
                {{ e.postName }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
        <div :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1
                    }">
          <a-button
            :style="{ marginRight: '8px' }"
            @click="addPersonCancel"
          >
            取消
          </a-button>
          <a-button
            type="primary"
            @click="personAddClick"
          >提交</a-button>
        </div>
      </a-form-model>
    </a-drawer>

    <!-- 调岗 -->
    <a-drawer
      :visible="changeGwView"
      title="人员调整"
      :width="500"
      @close="changeGwCancel"
      :closable="true"
    >
      <a-form-model :model="changeGwForm">
        <a-form-model-item
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          label="调整后组织"
        >
          <a-tree-select
            v-model="changeGwForm.organId"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="commData"
            placeholder="请选择组织"
            tree-default-expand-all
            @change="handleOrganChange"
          ></a-tree-select>
        </a-form-model-item>
        <a-form-model-item
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          label="调整后岗位"
        >
          <a-select
            placeholder="请选择岗位"
            option-filter-prop="children"
            v-model="changeGwForm.postId"
            style="width: 100%"
          >
            <template v-for="(e, key) in selectPost">
              <a-select-option v-bind:key="e.postId" :value="e.postId">
                {{ e.postName }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
        <div :style="{
                        right: 0,
                        bottom: '50%',
                        width: '100%',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1
                    }">
          <a-table
            :columns="changeUserCol"
            :data-source="changeGwForm.personList"
            :bordered="true"
            style="margin-top: 20px"
            size="small"
            :pagination="false"
          ></a-table>
        </div>
        <div :style="{
                        position: 'absolute',
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                        zIndex: 1
                    }">
          <a-button
            :style="{ marginRight: '8px' }"
            @click="changeGwCancel"
          >
            取消
          </a-button>
          <a-popconfirm
            placement="top"
            ok-text="确认"
            cancel-text="取消"
            @confirm="changeGwBySelect"
          >
            <template slot="title">
              <p>该操作不可撤回,是否确认</p>
            </template>
            <a-button type="primary">提交</a-button>
          </a-popconfirm>
          <!-- <a-button type="primary" @click="">
						提交
					</a-button> -->
        </div>
      </a-form-model>
    </a-drawer>

    <!-- 导入人员数据 -->
    <a-modal
      v-model="importView"
      title="导入人员数据"
      width="600px"
      :footer="null"
      @cancel="importCancel"
    >
      <a-form-model :model="importForm">
        <!-- 导入范围 -->
        <a-form-model-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 16 }"
          label="导入范围"
        >
          <a-tree-select
            v-model="importForm.organId"
            style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="commData"
            placeholder="请选择导入范围"
            tree-default-expand-all
            :disabled="true"
          ></a-tree-select>
          <p style="margin-top: 5px; font-size: 12px; color: #999;">
            导入的人员将归属于所选组织
          </p>
        </a-form-model-item>

        <!-- 导入模式 -->
        <a-form-model-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 16 }"
          label="导入模式"
        >
          <a-radio-group v-model="importForm.importMode">
            <a-radio :value="1">增量模式</a-radio>
            <a-radio :value="2">全量模式</a-radio>
          </a-radio-group>
          <div style="margin-top: 5px; padding: 8px; background-color: #f5f5f5; border-radius: 4px; font-size: 12px;">
            <p v-if="importForm.importMode === 1">
              <a-icon type="info-circle" style="color: #1890ff; margin-right: 4px;"></a-icon>
              增量模式：仅添加新数据，不影响现有数据
            </p>
            <p v-else>
              <a-icon type="info-circle" style="color: #faad14; margin-right: 4px;"></a-icon>
              全量模式：完全覆盖现有数据，文件中不存在的人员将被视为离职
            </p>
          </div>
        </a-form-model-item>

        <!-- 文件上传 -->
        <a-form-model-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 16 }"
          label="文件上传"
        >
          <div style="border: 2px dashed #d9d9d9; border-radius: 6px; padding: 40px 20px; text-align: center;">
            <a-upload
              v-model="importForm.fileList"
              :multiple="false"
              accept=".xlsx,.xls"
              :before-upload="beforeUpload"
              :custom-request="customUpload"
              :show-upload-list="false"
            >
              <div style="cursor: pointer;">
                <a-icon type="cloud-upload" style="font-size: 48px; color: #1890ff;"></a-icon>
                <p style="margin-top: 8px;">拖放Excel文件到此处，或</p>
                <a-button type="primary" style="margin-top: 8px;">
                  <a-icon type="upload"></a-icon> 选择文件
                </a-button>
                <p style="margin-top: 8px; font-size: 12px; color: #999;">
                  支持 .xlsx 格式，文件大小不超过 10MB
                </p>
              </div>
            </a-upload>
          </div>
          <div v-if="importForm.fileName" style="margin-top: 16px; padding: 8px; background-color: #e6f7ff; border-radius: 4px;">
            <a-icon type="file-excel" style="color: #52c41a; margin-right: 8px;"></a-icon>
            {{ importForm.fileName }}
            <a-icon type="close-circle" style="margin-left: 12px; cursor: pointer;" @click="clearFile"></a-icon>
          </div>
        </a-form-model-item>

        <!-- 下载模板 -->
        <a-form-model-item
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 16 }"
        >
          <a @click="downloadTemplate" style="color: #1890ff; text-decoration: none;">
            <a-icon type="download" style="margin-right: 4px;"></a-icon> 下载导入模板
          </a>
        </a-form-model-item>
      </a-form-model>

      <div style="
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 100%;
                        borderTop: 1px solid #e9e9e9;
                        padding: 10px 16px;
                        background: #fff;
                        textAlign: right;
                        zIndex: 1
                    ">
        <a-button
          @click="importCancel"
          style="margin-right: 12px;"
        >
          取消
        </a-button>
        <a-button
          type="primary"
          @click="confirmImport"
          :loading="importLoading"
          :disabled="!importForm.organId || !importForm.fileName"
        >
          确认导入
        </a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import {
  queryOrganList,
  eidtOrganNode,
  addOrganNode,
  getBasicSysMenu,
  getOptionSysMenu,
  addGwSysMenu,
  initGwTable,
  getEditViewMenu,
  editGwSysMenu,
  deleteGw,
  initPerTable,
  getPerson,
  getSelcetOrganGw,
  addPersonGw,
  deletePersonGw,
  deletePersonGwSelect,
  getGwByOrganId,
  changeGw,
  getPositionTree,
  getTotalPerson,
  changeSort,
  exportPersonnel,
  importPersonnel,
  getManageOrganList,
  saveManageOrganList,
  checkManagePermission
  // searchOrganNode
} from '@/services/organMgr.js';
import { getPositionList } from '@/services/system';
export default {
  data () {
    return {
      searchValue: '',
      expandedKeys: [],
      selectedKeys: [],
      autoExpandParent: true,
      selectPostForm: {
        postId: undefined
      },
      postList: [],

      gData: [],
      //展开的节点
      //	expandedKeys:[],
      //组织type
      organType: 1,
      // 组织数名称修改
      editTreeView: false,
      //组织树 添加子节点
      addTreeView: false,
      //组织树 删除子节点
      deleteTreeView: false,
      //增加 节点
      addView: false,
      // 编辑节点
      editOrganForm: {
        id: '',
        preName: '',
        editName: '',
        inputType: ''
      },
      // 添加节点
      addOrganChildrenForm: {
        pid: '',
        parentName: '',
        addName: '',
        inputType: ''
      },
      //
      addOrganForm: {
        pid: '',
        parentName: '',
        addName: '',
        inputType: '',
        sortNum: undefined
      },
      selectOrganAdd: {},
      form4: {
        content: '',
        inputType: ''
      },
      value: '',
      gwIscheck: true,
      ryIscheck: true,
      gwInfoView: false,
      personInfoView: false,
      personDrawerTitle: '',
      gwDrawerTitle: '新增',
      gwDrawerOrganTitle: undefined,
      modelView: 1,
      collapsed: false,
      gwColumns: [
        {
          title: '组织',
          dataIndex: 'organName',
          key: 'organName',
          align: 'center',
          className: 'repalceColor'
        },
        {
          title: '岗位',
          dataIndex: 'postName',
          key: 'postName',
          align: 'center',
          slots: {
            title: 'postName'
          },
          className: 'repalceColor'
        },
        {
          title: '人数',
          dataIndex: 'personNumber',
          key: 'personNumber',
          align: 'center',
          className: 'repalceColor'
        },
        {
          title: '分管范围',
          dataIndex: 'manageScope',
          key: 'manageScope',
          align: 'center',
          className: 'repalceColor',
          customRender: function(text, record) {
            if (record.manageOrganList && record.manageOrganList.length > 0) {
              return record.manageOrganList.map(item => item.organName).join(', ');
            } else {
              return '-';
            }
          }
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center',
          className: 'repalceColor'
        }
      ],
      gwData: [],
      paginationGw: {
        total: 0,
        defaultPageSize: 10,
        current: 1,
        showTotal: total => `共 ${total} 条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20'],
        onShowSizeChange: this.onShowGwSizeChange,
        onChange: this.gwPageChange
      },
      // paginationGw: this.$hdk.page(),
      // paginationGw: this.$hdk.page(),
      commData: [],
      copyCommData: [],
      dataList: [],
      searchDataParent: [],
      assignedList: [
        {
          name: '基础功能',
          id: 1,
          children: [
            {
              title: '工作台',
              id: '001',
              children: [
                {
                  name: '待办',
                  check: false,
                  id: '1'
                },
                {
                  name: '待阅',
                  check: false,
                  id: '1'
                },
                {
                  name: '最新公文',
                  check: false,
                  id: '1'
                }
              ]
            }
          ]
        }
      ],
      assignableList: [
        {
          name: '公文公告',
          id: 1,
          children: [
            {
              title: '通知公告',
              id: '001',
              children: [
                {
                  name: '发布通知公告',
                  check: false,
                  id: '1'
                },
                {
                  name: '通知公告审核',
                  check: false,
                  id: '1'
                },
                {
                  name: '通知公告管理',
                  check: false,
                  id: '1'
                }
              ]
            }
          ]
        }
      ],
      basicGwData: {
        name: '',
        childNumber: ''
      },
      gwForm: {
        type: 0,
        name: '',
        optionAry: [],
        organType: '',
        organId: '',
        postId: '',
        pid: ''
      },
      basicSysMenuList: [],
      assignedBasicGwList: [],
      optionalMenuGwList: [],
      checkBoxArray: [],
      //当前选中组织id
      organId: '',
      gwTotal: 0,
      gwPersonNumber: 0,
      //当前是人员还是岗位页面
      switchModel: 1,
      // ------------------人员
      personForm: {
        organType: 0,
        organId: 0
      },
      columnsPreson: [
        {
          title: '姓名',
          dataIndex: 'userName',
          key: 'userName',
          align: 'center',
          slots: {
            title: 'userName'
          },
          className: 'repalceColor'
        },
        {
          title: '组织',
          dataIndex: 'organName',
          key: 'organName',
          align: 'center',
          slots: {
            title: 'organName'
          },
          className: 'repalceColor'
        },
        {
          title: '岗位',
          dataIndex: 'postName',
          key: 'postName',
          align: 'center',
          slots: {
            title: 'postName'
          },
          className: 'repalceColor'
        },
        {
          title: '联系电话',
          dataIndex: 'mobile',
          key: 'mobile',
          align: 'center',
          slots: {
            title: 'mobile'
          },
          className: 'repalceColor'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: {
            customRender: 'action'
          },
          align: 'center',
          className: 'repalceColor'
        }
      ],
      dataPerson: [],
      paginationPer: {
        total: 0,
        defaultPageSize: 10,
        current: 1,
        showTotal: total => `共 ${total} 条数据`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20'],
        onShowSizeChange: this.onShowPerSizeChange,
        onChange: this.perPageChange
      },
      selectedRowKeys: [],
      addPerView: false,
      addPersonForm: {
        organId: '',
        personId: '',
        postId: '',
        typeId: 0
      },
      allPerSon: [],
      allPost: [],
      // ----下拉框页码
      selectCurrent: 1,
      selectTotal: 0,
      selectPageSize: 6,
      //调岗
      changeGwForm: {
        organId: '',
        postId: '',
        personList: [],
        typeId: ''
      },
      changeGwView: false,
      selectPost: [],
      keyAry: [],
      gwTreeData: [],
      personTotal: 0,
      changeForm: {
        sourceOrgan: undefined,
        sourceSortNum: undefined,
        targetOrgan: undefined,
        targetSortNum: undefined
      },
      changeUserCol: [
        {
          title: '姓名',
          dataIndex: 'userName',
          key: 'userName',
          align: 'center'
        },
        {
          title: '调整前组织',
          dataIndex: 'organName',
          key: 'organName',
          align: 'center'
        },
        {
          title: '调整前岗位',
          dataIndex: 'postName',
          key: 'postName',
          align: 'center'
        }
      ],
      addPersonFormRules: {
        personId: [
          {
            required: true,
            message: '请选择人员',
            trigger: 'change'
          }
        ],
        postId: [
          {
            required: true,
            message: '请选择岗位',
            trigger: 'change'
          }
        ]
      },
      filterUserName: '',
      exportLoading: false,
      // 组织分管相关
      form: {
        isManage: false,
        manageOrganList: [],
        manageType: 2,
        manageLevel: 1
      },
      // 分管类型下拉选项（对应顶部组织架构 tab）
      manageTypeOptions: [
        { value: 2, label: '党委组织架构' },
        { value: 3, label: '处室组织架构' },
        { value: 4, label: '教学组织架构' },
        { value: 5, label: '工会组织架构' },
        { value: 6, label: '教研组织架构' }
      ],
      // 组织树数据
      organTree: [],
      // 当前岗位信息
      currentPostId: null,
      currentOrganId: null,
      // 是否有分管权限
      hasManagePermission: false,
      // 导入相关
      importView: false,
      importForm: {
        organId: '',
        importMode: 1, // 1: 增量模式, 2: 全量模式
        fileList: [],
        fileName: '',
        file: null
      },
      importLoading: false
    }
  },
  created () {},
  
  mounted () {
    //获得所有人下拉框
    this.loadPost();
    this.getAllPerson();
    this.callback(2);
  },
  methods: {
    loadPost () {
      let that = this;
      getPositionList(undefined, 1).then(res => {
        if (res.data.code == 200) {
          that.postList = res.data.data;
        }
      });
    },
    changePost (id) {
      let post = this.postList.filter(item => item.postId == id)[0];
      this.gwForm.name = post.postName;
      this.gwForm.postId = post.postId;
    },
    selectClick (info, enent) {
      var Node = enent.selectedNodes[0];
      var dataRef = Node.data.props.dataRef;
      this.basicGwData.name = dataRef.title;
      this.organId = info[0];
      this.gwForm.organId = info[0];
      let that = this;
      var childAry = [];
      childAry.push(dataRef.key);
      if (dataRef.children != undefined) {
        this.basicGwData.childNumber = dataRef.children.length;
        var childrenAry = dataRef.children;
        if (childrenAry != null && childrenAry != undefined) {
          childrenAry.filter(function (first) {
            childAry.push(first.key);
            let firstObj = JSON.stringify(first);
            that.getChild(firstObj, childAry);
          });
        }
      } else {
        this.basicGwData.childNumber = 0;
      }
       
      // 检查用户是否有对该组织的分管权限
      this.checkUserPermission(info[0],this.organType);
      
      if (this.switchModel == 1) {
        //岗位页面
        //增加赋值
        this.paginationGw.current = 1;
        this.paginationGw.pageSize = 10;
        this.initGwTableData();
      } else {
        //人员页面
        this.paginationPer.current = 1;
        this.paginationPer.pageSize = 10;
        this.initPersonTableData();
      }
      getTotalPerson({
        typeId: this.organType,
        childAry: childAry
      }).then(res => {
        this.personTotal = res.data.total;
      });
    },
    async checkUserPermission(organId,type) {
      try {
        const response = await checkManagePermission(organId,type);
        this.hasManagePermission = response.data.hasPermission;
        console.log('User permission:', this.hasManagePermission);
      } catch (error) {
        console.error('检查权限失败:', error);
        this.hasManagePermission = false; // 默认无权限，防止没有权限的人误操作
      }
    },
    // 检查用户是否有操作权限
    hasPermission() {
      return this.hasManagePermission;
    },
    getChild (object, childAry) {
      var ob1 = JSON.parse(object);
      let that = this;
      if (ob1.children != null && ob1.children != undefined) {
        ob1.children.filter(function (first) {
          childAry.push(first.key);
          var ob2 = JSON.stringify(first);
          var obj2 = JSON.parse(ob2);
          if (obj2.children != null && obj2.children != undefined) {
            that.getChild(ob2, childAry);
          }
        });
      }
      return childAry;
    },
    onShowGwSizeChange (current, pageSize) {
      this.paginationGw.current = 1;
      this.paginationGw.pageSize = pageSize;
      this.initGwTableData();
    },
    gwPageChange (page, pageSize) {
      this.paginationGw.current = page;
      this.paginationGw.pageSize = pageSize;
      this.initGwTableData();
    },
    initGwTableData () {
       
      let info = {
        type: this.organType,
        organId: this.organId,
        pageSize: this.paginationGw.pageSize,
        pageCurrent: this.paginationGw.current
      };

      this.checkUserPermission(this.organId,this.organType)
      initGwTable(info).then(res => {
        this.gwData = res.data.record;
        this.paginationGw.total = res.data.total;
        this.gwPersonNumber = res.data.personTotal;
        this.gwTotal = res.data.total;
      });
    },
    changeStatus (value) {
      this.switchModel = value;
      this.modelView = value;
      if (value == 1) {
        this.initGwTableData();
      } else {
        this.initPersonTableData();
      }
    },
    callback (key) {
      //切换组织树
      this.organType = key;
      let that = this;
      this.form4.inputType = this.organType;
      this.paginationGw.current = 1;
      this.paginationGw.pageSize = 10;
      this.paginationPer.current = 1;
      this.paginationPer.pageSize = 10;
      queryOrganList(this.form4).then(res => {
        that.copyCommData = JSON.stringify(res.data.data);
        that.commData = res.data.data;
        that.personTotal = res.data.total;
        //初始化表格数据
        that.organId = res.data.data[0].key;
        that.gwForm.organId = res.data.data[0].key;
        that.basicGwData.name = res.data.data[0].title;
        if (res.data.data[0].children != null) {
          that.basicGwData.childNumber = res.data.data[0].children.length;
        } else {
          that.basicGwData.childNumber = 0;
        }
        if (that.switchModel == 1) {
          that.initGwTableData();
        } else {
          that.initPersonTableData();
        }
        that.generateList(that.commData);
      });
    },
    personDrawer (row, num) {
      if (num == 1) {
        //调岗
        console.log(row);
        this.changeGwForm.personList.push(row);
        this.changeGwView = true;
      } else if (num == 2) {
        let data = {
          postId: row.postId,
          personId: row.userId,
          organId: row.organId
        };
        deletePersonGw(data).then(res => {
          if (res.data.code == 200) {
            this.$message.success('删除成功！');

            this.paginationPer.current = 1;
            this.initPersonTableData();
          }
        });
      }
    },
    onClose () {
      this.personInfoView = false;
    },
    onCloseGw (e) {
      console.log(e);
      this.gwForm.name = '';
      this.optionalMenuGwList = [];
      this.gwInfoView = false;
      this.gwForm.postId = '';
      this.$refs.selectPostForm.resetFields();
      // 重置分管组织表单
      this.form = {
        isManage: false,
        manageOrganList: [],
        manageType: this.organType >= 2 && this.organType <= 6 ? this.organType : 2,
        manageLevel: 1
      };
    },
    handleIsManageChange(e) {
      this.form.isManage = e.target.value;
      if (this.form.isManage) {
        // 确保分管机构树已按所选分管类型加载
        this.loadManageOrganTree(this.form.manageType);
        // 默认选择当前组织（仅当当前组织类型与分管类型一致时）
        if (this.form.manageType == this.organType) {
          const currentOrgValue = `${this.organId}-${this.organType}`;
          this.form.manageOrganList = [currentOrgValue];
          console.log('Default manageOrganList:', this.form.manageOrganList);
        } else {
          this.form.manageOrganList = [];
        }
      } else {
        this.form.manageOrganList = [];
      }
    },
    handleManageTypeChange(value) {
      this.form.manageType = value;
      // 切换分管类型后清空已选范围，重新加载对应类型的机构树
      this.form.manageOrganList = [];
      this.loadManageOrganTree(value);
    },
    handleManageOrganChange(value) {
      this.form.manageOrganList = value;
    },
    async loadManageOrgan() {
      if (this.currentPostId && this.currentOrganId) {
        try {
          const response = await getManageOrganList(this.currentPostId, this.currentOrganId);
          const manageOrganList = response.data.manageOrganList;
          // 转换为选择器需要的格式
          this.form.manageOrganList = manageOrganList.map(item => `${item.organId}-${item.organType}`);
          this.form.isManage = manageOrganList.length > 0;
          // 回显分管类型、分管级数
          if (response.data.manageType) {
            this.form.manageType = response.data.manageType;
            this.form.manageLevel = response.data.manageLevel;
          }
          if (this.form.isManage) {
            await this.loadManageOrganTree(this.form.manageType);
          }
        } catch (error) {
          console.error('加载分管组织失败:', error);
        }
      }
    },
    async saveManageOrgan() {
      if (!this.currentPostId || !this.currentOrganId) {
        this.$message.warning('请先保存岗位基本信息');
        return;
      }
      
      try {
        // 转换分管组织数据格式
        const manageOrganList = this.form.manageOrganList.map(item => {
          const [organId, organType] = item.split('-').map(Number);
          return {
            organId,
            organType
          };
        });
        
        // 保存分管组织
        await saveManageOrganList({
          postId: this.currentPostId,
          organId: this.currentOrganId,
          manageType: this.form.manageType,
          manageLevel: this.form.manageLevel,
          manageOrganList
        });
        
        this.$message.success('保存分管范围成功');
      } catch (error) {
        console.error('保存分管范围失败:', error);
        this.$message.error('保存分管范围失败，请联系管理员');
      }
    },
    async loadOrganTree() {
      // 按当前分管类型加载机构树
      await this.loadManageOrganTree(this.form.manageType || this.organType);
    },
    async loadManageOrganTree(type) {
      console.log('loadManageOrganTree type:', type);
      let treeData = [];
      // 分管类型与当前 tab 一致时直接复用左侧机构树数据，避免重复请求
      if (type == this.organType && this.commData && this.commData.length > 0) {
        treeData = this.commData;
      } else {
        const res = await queryOrganList({ inputType: type });
        treeData = res.data.data || [];
      }
      this.organTree = this.convertTreeData(treeData, type);
      console.log('organTree:', this.organTree);
    },
    convertTreeData(treeData, type) {
      console.log('Original treeData:', treeData);
      const converted = treeData.map(item => {
        const convertedItem = {
          title: item.title,
          value: `${item.key}-${type}`,
          key: `${item.key}-${type}`, // 添加唯一的key值
          children: []
        };
        if (item.children && item.children.length > 0) {
          convertedItem.children = this.convertTreeData(item.children, type);
        }
        return convertedItem;
      });
      console.log('Converted treeData:', converted);
      return converted;
    },
    //
    onContextMenuClick (treeKey, menuKey, title) {
      let that = this;
      console.log(menuKey);
      if (menuKey == 1) {
        //修改组织树名称
        this.editTreeView = true;
        this.editOrganForm.preName = title;
        this.editOrganForm.id = treeKey;
      } else if (menuKey == 2) {
        //添加节点
        this.addTreeView = true;
        this.addOrganChildrenForm.parentName = title;
        this.addOrganChildrenForm.pid = treeKey;
      } else if (menuKey == 3) {
        //删除节点
        this.deleteTreeView = true;
      } else if (menuKey == 4) {
        console.log(treeKey, title);
      } else if (menuKey == 5) {
        if (treeKey == that.commData[0].value) {
          this.$message.warning('当前机构为顶级机构');
          return;
        }
        let req = {
          organId: treeKey,
          type: that.organType,
          operation: 1
        };
        changeSort(req).then(res => {
          if (res.data.code == 200) {
            that.$message.success(res.data.message);
            that.callback(that.organType);
          }
        });
      } else if (menuKey == 6) {
        if (treeKey == that.commData[0].value) {
          that.$message.warning('当前机构为顶级机构');
          return;
        }
        let req = {
          organId: treeKey,
          type: that.organType,
          operation: 2
        };
        changeSort(req).then(res => {
          if (res.data.code == 200) {
            that.$message.success(res.data.message);
            that.callback(that.organType);
          }
        });
      }
      // console.log(`treeKey: ${treeKey}, menuKey: ${menuKey},title:${title}`);
    },
    handleEditClick () {
      this.editOrganForm.inputType = this.organType;
      let that = this;
      if (this.editOrganForm.editName == '') {
        this.$message.warning('请输入名称！');
      } else {
        eidtOrganNode(this.editOrganForm).then(res => {
          var code = res.data.code;
          if (code == 200) {
            this.$message.success('修改成功！');
            that.callback(that.organType);
            that.editTreeView = false;
            that.editOrganForm = {
              id: '',
              preName: '',
              editName: '',
              inputType: ''
            };
            that.editOrganForm.editName = '';
          }
        });
      }
    },
    editCancel () {
      this.editTreeView = false;
      this.editOrganForm = {
        id: '',
        preName: '',
        editName: '',
        inputType: ''
      };
      this.editOrganForm.editName = '';
    },
    handleAddClick () {
      this.addOrganChildrenForm.inputType = this.organType;
      let that = this;
      if (this.addOrganChildrenForm.addName == '') {
        this.$message.warning('请输入名称！');
      } else {
        // console.log(that.addOrganChildrenForm)
        addOrganNode(this.addOrganChildrenForm).then(res => {
          var code = res.data.code;
          if (code == 200) {
            this.$message.success('添加成功！');
            that.callback(that.organType);
            that.addTreeView = false;
            that.addOrganChildrenForm = {
              pid: '',
              parentName: '',
              addName: '',
              inputType: ''
            };
            that.addOrganChildrenForm.addName = '';
          }
        });
      }
    },
    addChildCancel () {
      this.addTreeView = false;
      this.addOrganChildrenForm = {
        pid: '',
        parentName: '',
        addName: '',
        inputType: ''
      };
      this.addOrganChildrenForm.addName = '';
    },

    handleTreeAddClick () {
      this.addOrganForm.inputType = this.organType;
      let that = this;
      if (this.addOrganForm.addName == '') {
        this.$message.warning('请输入名称！');
      } else {
        if (this.commData == undefined || this.commData == []) {
          addOrganNode(this.addOrganForm).then(res => {
            var code = res.data.code;
            if (code == 200) {
              this.$message.success('添加成功！');
              that.callback(that.organType);
              that.addView = false;
              that.addOrganForm = {
                pid: '',
                parentName: '',
                addName: '',
                inputType: '',
                sortNum: undefined
              };
              that.addOrganForm.addName = '';
              that.addOrganForm.pid = '';
            }
          });
        } else {
          if (this.addOrganForm.pid == '') {
            this.$message.warning('请选中所属组织名称！');
          } else {
            addOrganNode(this.addOrganForm).then(res => {
              var code = res.data.code;
              if (code == 200) {
                this.$message.success('添加成功！');
                that.callback(that.organType);
                that.addView = false;
                that.addOrganForm = {
                  pid: '',
                  parentName: '',
                  addName: '',
                  inputType: '',
                  sortNum: undefined
                };
                that.addOrganForm.addName = '';
                that.addOrganForm.pid = '';
              }
            });
          }
        }
      }
    },
    addTreeCancel () {
      this.addView = false;
      this.addOrganForm = {
        pid: '',
        parentName: '',
        addName: '',
        inputType: '',
        sortNum: undefined
      };
      this.addOrganForm.addName = '';
      this.addOrganForm.pid = '';
    },
    //删除组织提示框
    handleDeleteClick () { },
    //增加节点 按钮
    addClick () {
      this.addView = true;
    },
    //组织树查询
    searchTree () {
      this.form4.inputType = this.organType;
      let that = this;
      queryOrganList(this.form4).then(res => {
        that.commData = res.data.data;
        //初始化表格数据
        that.organId = res.data.data[0].key;
        that.gwForm.organId = res.data.data[0].key;
        that.basicGwData.name = res.data.data[0].title;
        that.basicGwData.childNumber = res.data.data[0].children.length;
        that.initGwTableData();
      });
    },
    gwOpenViewClick (val, scope) {
      if (val == 1) {
        this.gwDrawerTitle = '新增岗位功能权限';
        this.gwDrawerOrganTitle = this.basicGwData.name;
        this.gwForm.type = 1;
        this.getSysMenu(1);
        this.gwInfoView = true;
        // 重置分管组织表单
        this.form = {
          isManage: false,
          manageOrganList: [],
          manageType: this.organType >= 2 && this.organType <= 6 ? this.organType : 2,
          manageLevel: 1
        };
        this.currentPostId = null;
        this.currentOrganId = null;
        // 加载组织树
        this.loadOrganTree();
      } else if (val == 2) {
        this.gwDrawerTitle = '编辑岗位功能权限';
        this.gwDrawerOrganTitle = this.basicGwData.name;
        this.gwForm.type = 2;
        this.gwForm.postId = scope.postId;
        this.gwForm.name = scope.postName;
        this.getViewEditSysMenu(scope);
        this.gwInfoView = true;
        this.selectPostForm.postId = scope.postId;
        // 保存当前岗位信息
        this.currentPostId = scope.postId;
        this.currentOrganId = scope.organId;
        // 加载组织树
        this.loadOrganTree();
        // 加载分管组织信息
        this.loadManageOrgan();
      } else if (val == 3) {
        this.gwDrawerTitle = '查看岗位功能权限';
        this.gwDrawerOrganTitle = this.basicGwData.name;
        this.gwForm.type = 3;
        this.gwForm.name = scope.postName;
        this.getViewEditSysMenu(scope);
        this.gwInfoView = true;
        this.selectPostForm.postId = scope.postId;
        // 保存当前岗位信息
        this.currentPostId = scope.postId;
        this.currentOrganId = scope.organId;
        // 加载组织树
        this.loadOrganTree();
        // 加载分管组织信息
        this.loadManageOrgan();
      } else if (val == 4) {
        if (scope.personNumber != 0) {
          this.$message.warning('岗位下有人员信息，无法删除！');
          console.log(scope);
        } else {
          let info = {
            postId: scope.postId,
            organId: scope.organId
          };
          let that = this;
          deleteGw(info).then(res => {
            if (res.data.code == 200) {
              this.$message.success('删除成功！');
              that.paginationGw.current = 1;
              that.initGwTableData();
            }
          });
        }
      }
    },
    //查看，编辑
    getViewEditSysMenu (scope) {
      let info = {
        organId: scope.organId,
        postId: scope.postId
      };
      getBasicSysMenu().then(res => {
        this.assignedBasicGwList = res.data.basicMenu;
      });
      getEditViewMenu(info).then(res => {
        this.optionalMenuGwList = res.data.optionalMenu;
      });
    },
    getSysMenu (val) {
      getBasicSysMenu().then(res => {
        this.assignedBasicGwList = res.data.basicMenu;
      });
      getOptionSysMenu(val).then(res => {
        this.optionalMenuGwList = res.data.optionalMenu;
      });
      getPositionTree(this.organId).then(res => {
        this.gwTreeData = res.data.data;
      });
    },
    //全选操作
    changAll (e, firstId, secondId) {
      let checkFirst = this.optionalMenuGwList.filter(item => item.id == firstId)[0];
      let checkSecond = checkFirst.children.filter(item => item.id == secondId)[0];
      console.log(e);
      checkSecond.check = e.target.checked;
      if (e.target.checked) {
        checkSecond.children.forEach(item => {
          item.check = true;
          //全选 取消次级选中样式
          checkSecond.allCheck = false;
        });
      } else {
        checkSecond.children.forEach(item => {
          item.check = false;
          //全不选 取消次级选中样式
          checkSecond.allCheck = false;
        });
      }
      //顶级菜单 选中
      checkFirst.check = false;
      checkFirst.children.forEach(item => {
        //二级菜单如果有选中 顶级菜单也选中添加
        if (item.check || item.allCheck) {
          checkFirst.check = true;
        }
      });
    },
    //单选操作
    onChange (e, firstId, secondId, id) {
      let checkFirst = this.optionalMenuGwList.filter(item => item.id == firstId)[0];
      let checkSecond = checkFirst.children.filter(item => item.id == secondId)[0];
      let checkObject = checkSecond.children.filter(item => item.id == id)[0];
      checkObject.check = e.target.checked;
      //细项赋值
      checkObject.check = e.target.checked;
      //是否全选判断
      checkSecond.check = true;
      //次级选中
      checkSecond.allCheck = false;
      checkSecond.children.forEach(item => {
        if (!item.check) {
          //如果有一个未选中 取消全选
          checkSecond.check = false;
        } else {
          //如果有一个已选中 选中次级选中样式
          checkSecond.allCheck = true;
        }
      });
      //如果全选 取消次级选中样式
      if (checkSecond.check) {
        checkSecond.allCheck = false;
      }
      //顶级菜单 选中
      checkFirst.check = false;
      checkFirst.children.forEach(item => {
        //二级菜单如果有选中 顶级菜单也选中添加
        if (item.check || item.allCheck) {
          checkFirst.check = true;
        }
      });
    },
    gwSubClick () {
      var type = this.gwForm.type;
      let that = this;
      //新增
      if (type == 1) {
        if (this.gwForm.postId == null || this.gwForm.postId == '') {
          this.$message.warning('请选择岗位');
        } else {
          var optionAry = [];
          this.optionalMenuGwList.filter(function (first) {
            //第一层
            if (first.children != null && first.children.length > 0) {
              first.children.filter(function (second) {
                //第二层
                var check = true;
                if (second.children != null && second.children.length > 0) {
                  second.children.filter(function (thirds) {
                    //第三层
                    if (thirds.check == true) {
                      optionAry.push(thirds.id);
                    } else {
                      check = false;
                    }
                  });
                }
                if (check) {
                  optionAry.push(second.id);
                }
              });
            }
          });
          //提交
          this.gwForm.organType = this.organType;
          this.gwForm.optionAry = optionAry;
          addGwSysMenu(this.gwForm).then(res => {
            if (res.data.code == 200) {
              // 保存分管组织信息
              if (that.form.isManage) {
                that.saveManageOrganAfterSave(that.gwForm.postId, that.organId);
              } else {
                that.$message.success('添加成功！');
                that.initGwTableData();
                that.gwInfoView = false;
                that.gwForm.name = '';
                that.gwForm.postId = '';
                that.$refs.selectPostForm.resetFields();
              }
            }
          });
        }
      } else if (type == 2) {
        //编辑
        if (this.gwForm.name == null || this.gwForm.name == '') {
          this.$message.warning('请输入岗位名称！');
        } else {
          var eidtOptionAry = [];
          this.optionalMenuGwList.filter(function (first) {
            //第一层
            first.children?.filter(function (second) {
              //第二层
              var check = true;
              second.children?.filter(function (thirds) {
                //第三层
                if (thirds.check == true) {
                  eidtOptionAry.push(thirds.id);
                } else {
                  check = false;
                }
              });
              if (check) {
                eidtOptionAry.push(second.id);
              }
            });
          });
          //提交
          this.gwForm.organType = this.organType;
          this.gwForm.optionAry = eidtOptionAry;
          editGwSysMenu(this.gwForm).then(res => {
            if (res.data.code == 200) {
              // 保存分管组织信息
              if (that.form.isManage) {
                that.saveManageOrganAfterSave(that.gwForm.postId, that.organId);
              } else {
                // 如果不需要分管组织，删除原有的分管组织信息
                that.deleteManageOrgan(that.gwForm.postId, that.organId);
              }
            }
          });
        }
      }
    },
    async saveManageOrganAfterSave(postId, organId) {
      try {
        // 转换分管组织数据格式
        const manageOrganList = this.form.manageOrganList.map(item => {
          const [organId, organType] = item.split('-').map(Number);
          return {
            organId,
            organType
          };
        });
        
        // 保存分管组织
        await saveManageOrganList({
          postId: postId,
          organId: organId,
          manageType: this.form.manageType,
          manageLevel: this.form.manageLevel,
          manageOrganList
        });
        
        this.$message.success('保存成功！');
        this.initGwTableData();
        this.gwInfoView = false;
        this.gwForm.name = '';
        this.gwForm.postId = '';
        this.$refs.selectPostForm.resetFields();
      } catch (error) {
        console.error('保存分管范围失败:', error);
        this.$message.error('保存分管范围失败，请联系管理员');
      }
    },
    async deleteManageOrgan(postId, organId) {
      try {
        // 保存空的分管组织列表，会删除原有的分管组织信息
        await saveManageOrganList({
          postId: postId,
          organId: organId,
          manageOrganList: []
        });
        
        this.$message.success('修改成功！');
        this.initGwTableData();
        this.gwInfoView = false;
        this.gwForm.name = '';
        this.gwForm.postId = '';
        this.$refs.selectPostForm.resetFields();
      } catch (error) {
        console.error('删除分管范围失败:', error);
        this.$message.error('删除分管范围失败，请联系管理员');
      }
    },
    // ---------------------------人员
    initPersonTableData () {
      let info = {
        type: this.organType,
        organId: this.organId,
        pageSize: this.paginationPer.pageSize,
        pageCurrent: this.paginationPer.current,
        organName: this.basicGwData.name
      };
      this.checkUserPermission(this.organId,this.organType)
      initPerTable(info).then(res => {
        this.dataPerson = res.data.records;
        this.paginationPer.total = res.data.total;
        this.gwPersonNumber = res.data.total;
      });
    },
    //表格选中
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    onShowPerSizeChange (current, pageSize) {
      this.paginationPer.current = 1;
      this.paginationPer.pageSize = pageSize;
      this.initPersonTableData();
    },
    perPageChange (page, pageSize) {
      this.paginationPer.current = page;
      this.paginationPer.pageSize = pageSize;

      this.initPersonTableData();
    },
    //
    handleChange (value) {
      console.log(`selected ${value}`);
    },
    filterOption (input, option) {
      console.log(input, option);
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptionUser (value) {
      let that = this;
      this.selectCurrent = 1;
      let obj = {
        selectPageSize: this.selectPageSize,
        selectPageCurrent: this.selectCurrent,
        userName: value
      };
      this.filterUserName = value
      getPerson(obj).then(res => {
        that.selectTotal = res.data.total;
        that.allPerSon = res.data.records;
      });
    },
    //
    handlePostChange (value) {
      console.log(`selected ${value}`);
    },

    filterPostOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    openAddPerView () {
      this.addPerView = true;
      this.getAllPerson();
      this.selcetOrganGw();
    },
    getAllPerson () {
      //获得所有person
      let that = this;
      let obj = {
        selectPageSize: this.selectPageSize,
        selectPageCurrent: this.selectCurrent
      };
      getPerson(obj).then(res => {
        that.selectTotal = res.data.total;
        that.allPerSon = res.data.records;
      });
    },
    //
    selectPageChange (page) {
      let that = this;
      this.selectCurrent = page;
      let obj = {
        selectPageSize: this.selectPageSize,
        selectPageCurrent: this.selectCurrent,
        userName: this.filterUserName
      };
      getPerson(obj).then(res => {
        that.selectTotal = res.data.total;
        that.allPerSon = res.data.records;
      });
    },
    //
    selcetOrganGw () {
      let that = this;
      let data = {
        organId: this.organId,
        type: this.organType
      };
      getSelcetOrganGw(data).then(res => {
        that.allPost = res.data.data;
      });
    },
    personAddClick () {
      this.addPersonForm.typeId = this.organType;
      this.addPersonForm.organId = this.organId;
      this.$refs.addPersonForm.validate(valid => {
        if (valid) {
          addPersonGw(this.addPersonForm).then(res => {
            if (res.data.code == 200) {
              this.addPerView = false;

              this.$message.success('添加成功！');

              this.$refs.addPersonForm.resetFields();
              this.initPersonTableData();
            }
          });
        } else {
          return false;
        }
      });
    },
    addPersonCancel () {
      this.addPerView = false;
      this.$refs.addPersonForm.resetFields();
    },
    deleteSelect () {
      if (this.selectedRowKeys.length > 0) {
        let deteleAry = [];
        let that = this;
        this.selectedRowKeys.filter(function (item) {
          deteleAry.push(that.dataPerson[item]);
        });
        deletePersonGwSelect(deteleAry).then(res => {
          if (res.data.code == 200) {
            this.$message.success('删除成功！');
            that.initPersonTableData();
            that.selectedRowKeys = [];
          }
        });
      } else {
        this.$message.warning('请先选中数据！');
      }
    },
    handleGwChange () {
      let that = this;
      if (this.changeGwForm.organId != '') {
        if (this.changeGwForm.postId != '') {
          this.changeGwForm.typeId = this.organType;
          changeGw(this.changeGwForm).then(res => {
            if (res.data.code == 200) {
              this.$message.success('调整成功！');
              that.changeGwForm = {
                organId: '',
                postId: '',
                personList: [],
                typeId: ''
              };
              that.changeGwForm.personList = [];
              that.initPersonTableData();
              that.changeGwView = false;
            }
          });
        } else {
          this.$message.warning('请选中岗位！');
        }
      } else {
        this.$message.warning('请先选中组织！');
      }
    },
    handleOrganChange () {
      this.changeGwForm.postId = '';
      let obj = {
        type: this.organType,
        organId: this.changeGwForm.organId
      };
      let that = this;
      getGwByOrganId(obj).then(res => {
        that.selectPost = res.data.data;
      });
    },
    openChangeGw () {
      for (var i in this.selectedRowKeys) {
        this.changeGwForm.personList.push(this.dataPerson[i]);
      }
      this.changeGwView = true;
    },
    changeGwBySelect () {
      if (this.changeGwForm.personList.length > 0) {
        this.handleGwChange();
      } else {
        let deteleAry = [];
        let that = this;
        this.selectedRowKeys.filter(function (item) {
          deteleAry.push(that.dataPerson[item]);
        });
        console.log(deteleAry);
        this.changeGwForm.personList = deteleAry;
        if (this.changeGwForm.personList.length > 0) {
          this.handleGwChange();
        } else {
          this.$message.warning('请先选中数据！');
        }
      }
    },
    changeGwCancel () {
      this.changeGwForm = {
        organId: '',
        postId: '',
        personList: [],
        typeId: ''
      };
      this.changeGwForm.personList = [];
      this.initPersonTableData();
      this.changeGwView = false;
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onSearch (e) {
      console.log(123123);
      const { dataList, getParentKey } = this;
      const value = e.target.value;
      // 需要展开的节点
      const expandedKeys = dataList
        .map(item => {
          if (item.title.indexOf(value) > -1) {
            return getParentKey(item.key, this.commData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);

      console.log('====>', expandedKeys);
      // 如果搜索条件不为空，进行筛选，反之数据还原
      if (value) {
        this.commData = JSON.parse(this.copyCommData);
        // 调用筛选方法
        this.commData = this.arrayTreeFilter(this.commData, this.filterFn, value);
      } else {
        console.log('========>', this.copyCommData);
        this.commData = JSON.parse(this.copyCommData);
      }

      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    },
    generateList (data) {
      console.log(45516515, data);
      const { generateList } = this;
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        this.dataList.push({ key: node.key, title: node.title });
        if (node.children) {
          generateList(node.children);
        }
      }
    },
    getParentKey (key, tree) {
      const { getParentKey } = this;
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key;
          } else if (getParentKey(key, node.children)) {
            parentKey = getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    arrayTreeFilter (data, predicate, filterText) {
      const nodes = data;
      // 如果已经没有节点了，结束递归
      if (!(nodes && nodes.length)) {
        return;
      }
      const newChildren = [];
      for (const node of nodes) {
        if (predicate(node, filterText)) {
          // 如果自己（节点）符合条件，直接加入到新的节点集
          newChildren.push(node);
          // 并接着处理其 children,（因为父节点符合，子节点一定要在，所以这一步就不递归了）
          node.children = this.arrayTreeFilter(node.children, predicate, filterText);
        } else {
          // 如果自己不符合条件，需要根据子集来判断它是否将其加入新节点集
          // 根据递归调用 arrayTreeFilter() 的返回值来判断
          const subs = this.arrayTreeFilter(node.children, predicate, filterText);
          // 以下两个条件任何一个成立，当前节点都应该加入到新子节点集中
          // 1. 子孙节点中存在符合条件的，即 subs 数组中有值
          // 2. 自己本身符合条件
          if ((subs && subs.length) || predicate(node, filterText)) {
            node.children = subs;
            newChildren.push(node);
          }
        }
      }
      return newChildren;
    },
    filterFn (data, filterText) {
      //过滤函数
      if (!filterText) {
        return true;
      }
      return new RegExp(filterText, 'i').test(data.title); //我是一title过滤 ，你可以根据自己需求改动
    },
    handleExport () {
      if (!this.organId) {
        this.$message.warning('请先选择一个组织')
        return
      }
      this.exportLoading = true
      const params = {
        type: this.organType,
        organId: this.organId
      }
      exportPersonnel(params).then(blob => {
        this.exportLoading = false
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = '人员档案.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      }).catch(() => {
        this.exportLoading = false
        this.$message.error('导出失败，请联系管理员')
      })
    },
    handleImport () {
      this.importForm.organId = this.organId
      this.importView = true
    },
    importCancel () {
      this.importView = false
      this.importForm = {
        organId: '',
        importMode: 1,
        fileList: [],
        fileName: '',
        file: null
      }
    },
    beforeUpload (file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel'
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isExcel) {
        this.$message.error('只能上传 Excel 文件！')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB！')
        return false
      }

      this.importForm.fileName = file.name
      this.importForm.file = file
      return false // 阻止自动上传
    },
    customUpload (options) {
      // 自定义上传逻辑，这里只是获取文件
      console.log('Custom upload:', options)
    },
    clearFile () {
      this.importForm.fileName = ''
      this.importForm.file = null
      this.importForm.fileList = []
    },
    async downloadTemplate () {
      const url = '/api/organ/downloadImportTemplate'
      const fileName = '人员导入模板.xlsx'
      
      try {
        // 发起请求获取文件blob
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': localStorage.getItem('token') || sessionStorage.getItem('token') || ''
          }
        })

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const blob = await response.blob()
        
        // 创建下载链接并触发下载
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', fileName)
        
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        
        // 释放创建的URL对象
        window.URL.revokeObjectURL(downloadUrl)
      } catch (error) {
        console.error('下载模板失败:', error)
        this.$message.error('下载模板失败，请重试')
      }
    },
    confirmImport () {
      if (this.importForm.importMode === 2) {
        // 全量模式二次确认
        this.$confirm('全量导入将覆盖现有数据，文件中不存在的人员将被视为离职。此操作不可撤销，确定继续吗？', '确认全量导入', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doImport()
        })
      } else {
        this.doImport()
      }
    },
    doImport () {
      this.importLoading = true
      const formData = new FormData()
      formData.append('organId', this.importForm.organId)
      formData.append('importMode', this.importForm.importMode)
      formData.append('file', this.importForm.file)
      formData.append('organType', this.organType)

      // 调用导入接口
      importPersonnel(formData).then(res => {
        this.importLoading = false
        // 检查响应结构，支持直接返回code和message的情况
        const response = res.data || res
        if (response.code === 200) {
          this.$message.success('导入成功！')
          this.importCancel()
          // 刷新人员列表
          this.initPersonTableData()
        } else {
          this.$message.error(`导入失败：${response.message}`)
        }
      }).catch(error => {
        this.importLoading = false
        this.$message.error('导入失败：网络错误')
        console.error('导入失败:', error)
      })
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-checkbox-disabled + span {
  color: #606266;
  cursor: not-allowed;
}
// #app {
//     height: calc(100% - 256px);
// }
/deep/ .ant-table-scroll {
  min-height: calc(100vh - 450px) !important;
}
.container {
  display: flex;
  flex-direction: column;
  // width: 100%;
  // height: 100%;
  margin-bottom: 0;
  // padding-bottom: 20rpx;
}

/deep/.ant-table-pagination.ant-pagination {
  margin: 40px 0 0 0;
  white-space: nowrap;
}

.div1 {
  border: 1px solid rgb(212, 212, 212);
  height: 100%;
  display: flex;
  flex-direction: column;
}

/deep/ .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
  background-color: rgba(24, 144, 255);
  //background-color: #1890ff;
  color: #fefefe;
}

.ant-table-thead > tr > th {
  text-align: center !important;
  font-size: 15px !important;
  background-color: #58adfc !important;
}

.ant-table-thead > tr > th > span {
  color: white;
}

.content {
}

.qw {
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 0px;
  margin: 15px;
}

.head {
  margin: 15px;
}

.span1 {
  margin-left: 15px;
  font-size: 15px;
  font-weight: bold;
}

.span2 {
  margin-top: 10px;
  margin-left: 15px;
  font-size: 10px;
  font-weight: bold;
}

/deep/ .ant-drawer-body {
  margin-bottom: 50px;
}

.drawerCotent {
  margin-bottom: 15px;
}
.drawerCotent-last {
  margin-bottom: 50px;
}
</style>
<style>
.ant-select-dropdown-menu::-webkit-scrollbar-thumb {
  background-color: #409eff;
  background-clip: padding-box;
  min-height: 1.75rem;
  border-radius: 3.125rem;
}

.ant-select-dropdown-menu::-webkit-scrollbar-track-piece {
  background-color: white;
  border-radius: 0.9375rem;
}

.ant-select-dropdown-menu::-webkit-scrollbar {
  width: 0.1875rem;
  height: 0.5625rem;
}
</style>
